import { ENVIRONMENT } from '@evc/platform';
import type { SharedEnv } from '@shared/services/config/config.type';

export { ENVIRONMENT } from '@evc/platform';

export type AppEnv = SharedEnv;

export const environment: AppEnv = {
  APP_NAME: 'admin',
  ENV: ENVIRONMENT.production,
  USE_CONNECT_PLATFORM: true,
  AUTH_FORCE_ORGANIZATION: true,
};
